import { gql } from '@apollo/client'

/**
 * Operaciones GraphQL del módulo `users`.
 *
 * NOTA: estos contratos los proveyó el equipo de backend pero AÚN NO están
 * desplegados en el gateway (`portalListOrgMembers`, `portalInviteOrgMember`,
 * etc. no aparecen en la introspección al momento de escribir esto).
 *
 * Cuando estén en producción, migrar a archivos `.graphql` co-localizados y
 * dejar que codegen genere los tipos. La forma de los inputs/outputs no
 * cambiará — sólo se reemplaza el `gql` template literal por el
 * `<Operation>Document` importado de `@/graphql/generated/graphql`.
 */

// ─── Tipos del dominio ──────────────────────────────────────────────────────

/** Item de la lista de miembros — match exacto con `PortalOrgMemberItem`. */
export interface OrgMember {
  id: string
  email: string
  firstName: string
  lastName: string
  /** Nombre del rol como string (ej. "ORG_OWNER"). */
  role: string
  isActive: boolean
  /** ISO string. */
  registeredAt: string
  photoSrc: string | null
}

export interface PortalOrgMembersResponse {
  items: OrgMember[]
  totalItems: number
}

export interface PortalInviteOrgMemberInput {
  email: string
  role: string
  firstName?: string | null
  lastName?: string | null
  businessesIds: string[]
}

export interface PortalUpdateOrgMemberRoleInput {
  memberId: string
  /** ORG_MANAGER | ORG_ACCOUNTANT; null = QUITAR el rol (goal portal-roles-2). */
  newRole: string | null
}

// ─── Operaciones ────────────────────────────────────────────────────────────

export const PORTAL_LIST_ORG_MEMBERS = gql`
  query PortalListOrgMembers($take: Int!, $skip: Int!) {
    portalListOrgMembers(take: $take, skip: $skip) {
      items {
        id
        email
        firstName
        lastName
        role
        isActive
        registeredAt
        photoSrc
      }
      totalItems
    }
  }
`

export interface PortalListOrgMembersData {
  portalListOrgMembers: PortalOrgMembersResponse
}
export interface PortalListOrgMembersVars {
  take: number
  skip: number
}

export const PORTAL_INVITE_ORG_MEMBER = gql`
  mutation PortalInviteOrgMember($input: PortalInviteOrgMemberInput!) {
    portalInviteOrgMember(input: $input)
  }
`

export interface PortalInviteOrgMemberData {
  portalInviteOrgMember: boolean
}
export interface PortalInviteOrgMemberVars {
  input: PortalInviteOrgMemberInput
}

export const PORTAL_UPDATE_ORG_MEMBER_ROLE = gql`
  mutation PortalUpdateOrgMemberRole($input: PortalUpdateOrgMemberRoleInput!) {
    portalUpdateOrgMemberRole(input: $input)
  }
`

export interface PortalUpdateOrgMemberRoleData {
  portalUpdateOrgMemberRole: boolean
}
export interface PortalUpdateOrgMemberRoleVars {
  input: PortalUpdateOrgMemberRoleInput
}

export const PORTAL_REMOVE_ORG_MEMBER = gql`
  mutation PortalRemoveOrgMember($memberId: String!) {
    portalRemoveOrgMember(memberId: $memberId)
  }
`

export interface PortalRemoveOrgMemberData {
  portalRemoveOrgMember: boolean
}
export interface PortalRemoveOrgMemberVars {
  memberId: string
}
